import type { SxProps, Theme } from '@mui/material';
import { Box, Button, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type ErrorMessageProps = {
  msg: ReactNode;
  sx?: SxProps<Theme>;
};

const ErrorMessage = ({ msg, sx = { marginTop: 10 } }: ErrorMessageProps) => {
  const { t } = useTranslation();

  const tryAgainHandler = () => {
    window.location.reload();
  };

  return (
    <Box
      data-testid="error-message"
      sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', ...sx }}
    >
      <Typography
        data-testid="error-message-message"
        variant="h5"
        component="p"
        sx={{
          textAlign: 'center',
          px: 1,
          color: (theme) => theme.palette.error.light,
        }}
      >
        {msg}
      </Typography>

      <Button
        data-testid="error-message-try-again"
        variant="text"
        onClick={tryAgainHandler}
        sx={{
          color: (theme) => theme.palette.info.main,
          textTransform: 'none',
        }}
      >
        {t('common.Messages.Error.PleaseTryAgain', {
          defaultValue: 'Please, try again!',
        })}
      </Button>
    </Box>
  );
};

export default ErrorMessage;
